export default "__VITE_PUBLIC_ASSET__b2a65717__"